var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-octagon-base",
    {
      staticClass: "journey-brick",
      class: _vm.classList,
      nativeOn: {
        click: function($event) {
          return _vm.handleClick($event)
        }
      }
    },
    [
      [
        _vm.showSettings
          ? _c(_vm.editorType, {
              tag: "component",
              attrs: {
                value: _vm.config,
                name: _vm.name,
                show: _vm.showSettings,
                availableConditions: _vm.availableConditions
              },
              on: {
                hide: function($event) {
                  _vm.showSettings = false
                },
                save: function($event) {
                  return _vm.$emit("settings-changed", $event)
                },
                delete: function($event) {
                  return _vm.$emit("delete-brick", false)
                }
              }
            })
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }